import { cn } from '../lib/utils';
import type { Edition } from '../lib/types';

interface EditionBadgeProps {
  edition: Edition;
  onClick?: () => void;
  size?: 'sm' | 'md';
}

export function EditionBadge({ edition, onClick, size = 'sm' }: EditionBadgeProps) {
  const label = edition === '1st' ? '1st' : edition === 'shadowless' ? 'SHL' : 'UNL';

  const sizeClasses = size === 'sm'
    ? 'px-1.5 py-0.5 text-[10px]'
    : 'px-2 py-1 text-xs';

  const colorClasses = edition === '1st'
    ? 'bg-amber-500 text-black'
    : edition === 'shadowless'
      ? 'bg-slate-400 text-slate-900'
      : 'bg-muted text-muted-foreground';

  return (
    <span
      onClick={onClick}
      className={cn(
        'rounded font-bold uppercase',
        sizeClasses,
        colorClasses,
        onClick && 'cursor-pointer hover:opacity-80 active:scale-95 transition-all'
      )}
    >
      {label}
    </span>
  );
}
